import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6db47d4b"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "pc-card"
};
var _hoisted_2 = {
  class: "card-wrapper"
};
var _hoisted_3 = {
  class: "info-row name-and-picture-wrapper"
};
var _hoisted_4 = {
  class: "names-wrapper"
};
var _hoisted_5 = {
  class: "below-part-wrapper"
};
var _hoisted_6 = {
  class: "info-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_AnimatedPlaceHolder = _resolveComponent("AnimatedPlaceHolder");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_AnimatedPlaceHolder, {
    height: "20px",
    width: "100px"
  })]), _createVNode(_component_AnimatedPlaceHolder, {
    height: "40px",
    width: "40px"
  })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_AnimatedPlaceHolder, {
    height: "10px",
    width: "50%"
  }), _createVNode(_component_AnimatedPlaceHolder, {
    height: "10px",
    width: "20%"
  })])])])])]);
}